// Sumber tunggal nomor & link WhatsApp Customer Service.
// Ubah lewat env REACT_APP_WA_CS (tanpa tanda "+", format internasional),
// atau ubah default di bawah. Jangan hardcode nomor di komponen lain —
// import WA_CS_LINK dari sini.
export const WA_CS_NUMBER = process.env.REACT_APP_WA_CS || "6282357509078";
export const WA_CS_LINK = `https://wa.me/${WA_CS_NUMBER}`;

// Bentuk tampilan dari nomor yang sama, mis. "+62 823 5750 9078".
export const WA_CS_DISPLAY = (() => {
    const digits = String(WA_CS_NUMBER).replace(/\D/g, "");
    const local = digits.startsWith("62") ? digits.slice(2) : digits;
    const parts = local.match(/^(\d{3})(\d{4})(\d+)$/);

    return parts ? `+62 ${parts[1]} ${parts[2]} ${parts[3]}` : `+${digits}`;
})();
